import React, { Component } from 'react';
import Methodology from './Methodology';
import Spinner from '../common/Spinner/Spinner';
import config from '../../config';


class MethodologyContainer extends Component {
  state = {
    content: ''
  };

  async componentDidMount() {
    const res = await fetch(`${config.fetchURL}/pages?_embed&slug=modszertan`);
    const data = await res.json();

    this.setState({ content: data[0].acf.sajat_oldal });
  }

  render() {
    const { content } = this.state;

    if (content.length > 0) {
      return (
        <Methodology content={content} />
      );
    } else {
      return (
        <Spinner style={{ marginTop: '200px', marginBottom: '200px' }} />
      );
    }
  }
}


export default MethodologyContainer;



// WEBPACK FOOTER //
// ./src/components/Methodology/MethodologyContainer.js